import React, { Component, createRef } from 'react';
import axios from 'axios';
import { Link, Navigate } from "react-router-dom";
import Category from './category';
import List from './list/list';
import Two from './list/two';
import Large from './list/large';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Loader from '../general/loader';
import Subcategory from './subcategory';
import backArrow from '../../assets/backArrow.png'
import CategoryItemsDisplay from './CategoryItemsDisplay';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import Cart from './cart';


import bgStarsShape from '../../assets/stars-r.png';
import bgStarsShape2 from '../../assets/stars-l.png';

import Daniklogo from '../../assets/logo.png';

import SPLoader from '../general/spinnerLoader'






class Menu extends Component {

    

    settings = this.props.Settings;
    language = this.props.Language;

    state = {
        categories: [],
        selectCategory: [],
        selectSubCategory: 0,
        items: [],
        slide: [],
        loadSlide: false,
        loadCat: false,
        load: false,
        listview: "two",
        cart: false,
        isAnimationVisible: true,
    }

    constructor(props) {
        super(props);
        this.containerRef = createRef();

      }

     
    

    async componentDidMount() {
       


        // Get categories
        const {data} = await axios.get("https://manage.caviarmenu.com/api/categories/danik");
        this.setState({ categories: data }, ()=>{
            this.setState({loadCat: true});
            this.getCategoryName(-1);
        });

        {
            const {data} = await axios.get("https://manage.caviarmenu.com/api/items/danik");
            this.setState({ items: data }, ()=>{
                this.setState({load: true});
            });
        }

         {
            // Get Slideshows
            const {data} = await axios.get("https://manage.caviarmenu.com/api/slideshow/danik");
            this.setState({ slide: data }, ()=>{
                this.setState({loadSlide: true});
            });
        }

        this.layoutDirection();

        setTimeout(
            () => {
                this.setState({isAnimationVisible: false});
            }, 3500
        )

    }

    layoutDirection() {
        // if(this.props.Language != "en")
        //     document.getElementById("itemContainer").style.direction = "rtl";
        // else
        //     document.getElementById("itemContainer").style.direction = "ltr";
    }

    getCategoryName(id) {
        const category = id === -1 
            ? this.state.categories[0] 
            : this.state.categories.find(cat => cat.id === id);
    
        if (category) {
            this.setState({ selectCategory: category });
            if(category.subCat){
                this.setState({ selectSubCategory: category[0].subCategories[0] });
            }
        }
    }

    handleChange = async e => {
        await this.props.handleLangaugeSubmit(e);
        this.layoutDirection();
    }   

    handleListview = style => {
        this.setState({listview: style});
    }

    handleShowLangSelect = e => {
        this.setState({showLangSelect: e});
    }

    handleCartClose = close => {
        this.setState({cart: close});
    }

    handleCategory = e => {
        const selectedCategory = this.state.categories.find(category => category.id === e);
        
        if (selectedCategory) {
            this.setState({ loadCat: false });
            this.setState({ selectCategory: selectedCategory}, () => {
                this.setState({ loadCat: true,});
            });

            if(selectedCategory.subCat){
                this.setState({ selectSubCategory: selectedCategory.subCategories[0] });
            }


            

        }
    }
   
    

    handleSubCategory = e => {

        const selectedSubcategory = this.state.selectCategory?.subCategories?.find(category => category.id == e);        
        if (selectedSubcategory) {
            this.setState({ loadCat: false });
            this.setState({ selectSubCategory: selectedSubcategory }, () => {
                this.setState({ loadCat: true});
            });
        }
    }


    priceText(text){
        if(text == 'small')
            
            return (
                <span> 
                    {
                        this.props.Language == "en"? 'small'
                        : this.props.Language == "krd"? 'بچیک'
                        : 'صغیر'
                    } 
                </span>
            )
        else if(text == 'medium')
            return (
                <span>
                    {
                        this.props.Language == "en"? 'medium'
                        : this.props.Language == "krd" ? 'ناڤنجی'
                        : 'متوسط'
                    }
                </span>
            )
        else
            return <span>
                {
                    this.props.Language == "en" ? 'large'
                    : this.props.Language == "krd" ? 'مەزن'
                    : 'کبير'
                }
            </span>
    }


  
    
    




    render() {
        

        const isLtr = (this.props.Language == "en");

        return (
            <>
            <SPLoader></SPLoader>
            <div className='menu-items ani-fadeIn'>
                <div className="head ani-stb"  >

                    <div className="head-right">
                        <Link to={"/"}>
                                    <img src={Daniklogo} className='logo' alt="" />
                                </Link>

                        <div 
                            className='head-btn feedback-btn'
                            style={ {'fontFamily':'Exo 2'}}>
                                <Link to={"/feedback"}>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.51316 6.16182C8.51316 5.94438 8.33685 5.76807 8.11941 5.76807H3.78816C3.57072 5.76807 3.39441 5.94438 3.39441 6.16182C3.39441 6.37925 3.57072 6.55557 3.78816 6.55557H8.11941C8.33685 6.55557 8.51316 6.37925 8.51316 6.16182Z" fill="#FFFEF0" fillOpacity="0.8"/>
                                        <path d="M3.78724 7.75647C3.56981 7.75647 3.39349 7.93278 3.39349 8.15022C3.39349 8.36766 3.56981 8.54397 3.78724 8.54397H6.08368C6.30112 8.54397 6.47743 8.36766 6.47743 8.15022C6.47743 7.93278 6.30112 7.75647 6.08368 7.75647H3.78724Z" fill="#FFFEF0" fillOpacity="0.8"/>
                                        <path d="M11.1075 6.18364C10.8901 6.18364 10.7138 6.35996 10.7138 6.57739V9.76196C10.7138 10.3578 10.229 10.8426 9.63314 10.8426H6.99939C6.91407 10.8426 6.83095 10.8701 6.7627 10.9218L4.48857 12.632C4.43082 12.6753 4.37657 12.6573 4.34945 12.6425C4.32189 12.6285 4.27639 12.5939 4.27814 12.5235L4.32189 11.2503C4.32539 11.1436 4.28557 11.0399 4.21164 10.9633C4.1377 10.8863 4.03532 10.843 3.92857 10.843H2.09939C1.50351 10.843 1.01876 10.3587 1.01876 9.76239V4.55614C1.01876 3.95808 1.50351 3.47158 2.09939 3.47158H6.95126C7.1687 3.47158 7.34501 3.29527 7.34501 3.07783C7.34501 2.86039 7.1687 2.68408 6.95126 2.68408H2.09939C1.06951 2.68408 0.231262 3.52408 0.231262 4.55658V9.76239C0.231262 10.7923 1.06951 11.631 2.09939 11.631H3.52082L3.49107 12.4981C3.48057 12.8542 3.67001 13.178 3.98632 13.342C4.12151 13.4125 4.2672 13.447 4.41157 13.447C4.60539 13.447 4.79745 13.3845 4.96107 13.2624L7.13064 11.631H9.6327C10.6626 11.631 11.5008 10.7927 11.5008 9.76239V6.57783C11.5013 6.35996 11.3249 6.18364 11.1075 6.18364Z" fill="#FFFEF0" fillOpacity="0.8"/>
                                        <path d="M13.2359 2.43297C13.1646 2.21422 12.9892 2.05059 12.7665 1.99547L11.7603 1.74478L11.2108 0.865403C10.9671 0.474278 10.3309 0.475153 10.0877 0.865403L9.53819 1.74478L8.53194 1.99547C8.30925 2.05059 8.13338 2.21422 8.0625 2.43297C7.99163 2.65172 8.03713 2.88753 8.185 3.06384L8.85175 3.85747L8.77913 4.89172C8.76294 5.12097 8.86444 5.3384 9.05038 5.47359C9.16588 5.55759 9.3015 5.6009 9.43888 5.6009C9.52244 5.6009 9.60688 5.58472 9.68782 5.5519L10.6494 5.1634L11.6106 5.5519C11.8237 5.63853 12.0617 5.60878 12.2481 5.47403C12.434 5.33884 12.5355 5.1214 12.5198 4.89172L12.4471 3.85747L13.1139 3.0634C13.2613 2.88753 13.3073 2.65172 13.2359 2.43297ZM11.7414 3.4729C11.6758 3.55122 11.643 3.65184 11.6504 3.75422L11.7204 4.74734L10.7973 4.37415C10.7501 4.3549 10.6998 4.34528 10.6499 4.34528C10.6 4.34528 10.5497 4.3549 10.5024 4.37415L9.57975 4.74734L9.64932 3.75422C9.65632 3.65228 9.6235 3.55122 9.55832 3.4729L8.91825 2.71078L9.88425 2.46972C9.98313 2.44478 10.0689 2.38309 10.1227 2.29647L10.6503 1.45253L11.1779 2.29647C11.2322 2.38309 11.3175 2.44522 11.4164 2.46972L12.3824 2.71078L11.7414 3.4729Z" fill="#FFFEF0" fillOpacity="0.8"/>
                                    </svg>
                                    {
                                        this.props.Language == "en" ? 'Feedback'
                                        : this.props.Language == "krd" ? 'فیدباك'
                                        : 'فیدباك'
                                    } 
                                </Link>
                        </div>
                    </div>

                    <div className="head-left">

                        <div 
                                className='head-btn order-btn' 
                                onClick={()=> this.handleCartClose(true)}>
                                    <span className='cartQty'> { this.props.SumQty } </span> 
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.2146 4.70302H11.7999L9.83082 0.98375C9.72458 0.78307 9.47582 0.70651 9.27506 0.812757C9.07438 0.919004 8.99782 1.16785 9.10406 1.36852L10.8694 4.70302H3.12817L4.89355 1.36852C4.9998 1.16785 4.92324 0.919004 4.72256 0.812757C4.52193 0.706537 4.27304 0.78307 4.16679 0.98375L2.19769 4.70302H0.785421C0.352347 4.70302 0 5.05537 0 5.48844V6.40182C0 6.81667 0.323346 7.1572 0.731256 7.18516L2.11066 12.9201C2.15509 13.1049 2.32038 13.2351 2.51043 13.2351H11.4869C11.6768 13.2351 11.8421 13.105 11.8866 12.9203L13.2692 7.1851C13.6769 7.15692 14 6.8165 14 6.40182V5.48844C14 5.05537 13.6477 4.70302 13.2146 4.70302ZM0.822344 5.52537H13.1777V6.36487H0.822344V5.52537ZM11.8924 9.3875H10.0921L10.3669 7.18721H12.4228L11.8924 9.3875ZM7.41173 12.4128V10.2098H9.16072L8.88568 12.4128H7.41173ZM5.11536 12.4128L4.84007 10.2098H6.58939V12.4128H5.11536ZM1.57756 7.18721H3.63364L3.9086 9.3875H2.10679L1.57756 7.18721ZM4.46234 7.18721H6.58939V9.3875H4.73731L4.46234 7.18721ZM7.41173 9.3875V7.18721H9.53812L9.26341 9.3875H7.41173ZM2.30456 10.2098H4.01134L4.28663 12.4128H2.83443L2.30456 10.2098ZM11.163 12.4128H9.71441L9.98945 10.2098H11.6941L11.163 12.4128Z" fill="#F7F3E9"/>
                                </svg>
                        </div>

                        <div className="language">
                            <div 
                                    className='head-btn language-active' 
                                    // style={{'direction': `${this.props.Language != "en"? 'rtl': 'ltr'}`}}
                                    onClick={ () => this.handleShowLangSelect(true) }>
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.9707 10.6545C13.6455 9.55516 14.0018 8.29006 14 7.00013V6.99988C14.0018 5.70994 13.6454 4.44482 12.9706 3.34545L12.9668 3.33945C12.3408 2.31909 11.4635 1.47631 10.4189 0.891656C9.37425 0.307002 8.19714 4.89181e-06 7.00003 0C5.80292 -4.89169e-06 4.6258 0.306982 3.58117 0.891628C2.53653 1.47627 1.65927 2.31904 1.03323 3.3394L1.02934 3.34548C0.356213 4.44561 4.99633e-06 5.71027 0 6.99998C-4.99623e-06 8.2897 0.356193 9.55436 1.02931 10.6545L1.03326 10.6607C1.65932 11.681 2.53657 12.5238 3.5812 13.1084C4.62583 13.693 5.80293 14 7.00003 14C8.19713 14 9.37423 13.693 10.4189 13.1084C11.4635 12.5237 12.3407 11.6809 12.9668 10.6606L12.9707 10.6545ZM7.89476 12.8003C7.76137 12.929 7.60785 13.035 7.44025 13.1142C7.30269 13.1796 7.1523 13.2135 7 13.2135C6.8477 13.2135 6.69731 13.1796 6.55975 13.1142C6.24082 12.9513 5.9678 12.7111 5.76567 12.4154C5.35285 11.8189 5.04692 11.1551 4.86155 10.4537C5.57364 10.4099 6.28646 10.3876 7 10.3868C7.71325 10.3868 8.42611 10.4091 9.13858 10.4537C9.03597 10.8144 8.90781 11.1672 8.75507 11.5096C8.55394 11.9911 8.26184 12.4294 7.89476 12.8003ZM0.800203 7.39326H3.62364C3.64203 8.18111 3.72742 8.96595 3.87891 9.73932C3.10709 9.80723 2.33724 9.90052 1.56937 10.0192C1.11971 9.21244 0.856865 8.31509 0.800203 7.39326ZM1.56936 3.98084C2.33693 4.09979 3.10705 4.19309 3.87971 4.26075C3.72793 5.03406 3.64235 5.8189 3.62389 6.60675H0.800203C0.856861 5.68492 1.11971 4.78756 1.56936 3.98084ZM6.10524 1.1997C6.23862 1.07099 6.39215 0.964953 6.55975 0.885782C6.69731 0.82042 6.8477 0.786508 7 0.786508C7.1523 0.786508 7.30269 0.82042 7.44025 0.885782C7.75918 1.04869 8.0322 1.28894 8.23433 1.58457C8.64715 2.18111 8.95308 2.84489 9.13844 3.54625C8.42635 3.59007 7.71353 3.61239 7 3.61322C6.28676 3.61321 5.5739 3.59088 4.86142 3.54624C4.96403 3.18563 5.09219 2.83279 5.24493 2.4904C5.44606 2.00886 5.73816 1.57062 6.10524 1.1997ZM13.1998 6.60675H10.3764C10.358 5.8189 10.2726 5.03405 10.1211 4.26068C10.8929 4.19277 11.6628 4.09948 12.4306 3.98084C12.8803 4.78756 13.1431 5.68492 13.1998 6.60675ZM4.66996 9.67817C4.51614 8.92569 4.42927 8.16107 4.41036 7.39326H9.58972C9.57099 8.16106 9.48427 8.9257 9.3306 9.67819C8.55459 9.62727 7.77772 9.60129 7 9.60027C6.22285 9.60026 5.44617 9.62623 4.66996 9.67817ZM9.33004 4.32183C9.48385 5.07431 9.57072 5.83894 9.58963 6.60675H4.41028C4.42901 5.83894 4.51573 5.0743 4.6694 4.32179C5.44541 4.37271 6.22228 4.39868 7 4.39973C7.77716 4.39973 8.55384 4.37376 9.33004 4.32183ZM10.3761 7.39326H13.1998C13.1431 8.31509 12.8803 9.21244 12.4306 10.0192C11.6631 9.9002 10.8929 9.8069 10.1203 9.73925C10.2721 8.96594 10.3577 8.18111 10.3761 7.39326ZM11.9591 3.25693C11.288 3.35376 10.6148 3.43042 9.9397 3.48691C9.81837 3.03515 9.66187 2.59357 9.47166 2.16622C9.298 1.77296 9.07948 1.40107 8.82045 1.05797C10.0722 1.44188 11.1707 2.2115 11.9591 3.25693ZM2.60639 2.60638C3.32446 1.88763 4.20789 1.35598 5.17922 1.05806C5.16449 1.07715 5.14933 1.09539 5.1348 1.11487C4.63554 1.83359 4.27187 2.63752 4.06173 3.48703C3.38657 3.42985 2.71297 3.35315 2.04095 3.25693C2.21427 3.02736 2.40319 2.81 2.60639 2.60638ZM2.04094 10.7431C2.71204 10.6462 3.38516 10.5696 4.06029 10.5131C4.18163 10.9649 4.33812 11.4064 4.52834 11.8338C4.70201 12.227 4.92053 12.5989 5.17955 12.942C3.92775 12.5581 2.82926 11.7885 2.04094 10.7431ZM11.3936 11.3936C10.6755 12.1124 9.79211 12.644 8.82078 12.9419C8.83551 12.9228 8.85066 12.9046 8.8652 12.8851C9.36447 12.1664 9.72814 11.3625 9.93828 10.513C10.6134 10.5702 11.287 10.6469 11.9591 10.7431C11.7857 10.9726 11.5968 11.19 11.3936 11.3936Z" fill="#FFFEF0"/>
                                        </svg>
                                        <i className="fa-solid fa-chevron-down"></i>
                            </div>
                        </div>

                    </div>
                    
                </div>

                <div className='carousel ani-ltr'>
                    {
                        this.state.loadSlide 
                        ? 
                            <Carousel autoPlay={true} showThumbs={false} showStatus={false} showArrows={false} infiniteLoop={true}>
                                { this.state.slide.map(slide=> <div key={slide.id}><img src={slide.image}/></div>)}
                            </Carousel>
                        : 
                            <Loader></Loader>
                    }
                    
                </div>


                    
                <div className='categories ani-rtl' ref={this.containerRef}>

                    {
                        this.state.loadCat ?
                        <>
                        {this.state.categories.map((cat, index) => (
                            <Category 
                            key={index} 
                            Data={cat} 
                            Language={this.props.Language} 
                            handleCategory={this.handleCategory} 
                            Active={this.state.selectCategory.id === cat.id} 
                            />
                        ))}
                        </>
                        : <Loader></Loader>
                    }
                    
                </div>


              

                {
                    this.state.load ?
                    <> 
                    

                    <PhotoProvider maskOpacity={0.7} photoClassName={'photoProviderImg'} 

                    
                                overlayRender={ ({ images, index }) => {
                                    
                                    

                                    if(!images[index]){
                                        return null;
                                    }
                                    const data = images[index].overlay;                                                                
                                                                
                                    return (
                                        
                                    
                                        
                                        <div className={`item-photo-view`} style={ {'direction': isLtr? "ltr" : "rtl"} }>
                                           
                                           
                                    

                                            <div >
                                                <h5 style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}>
                                                    {
                                                        this.props.Language == "en" ? data.name_eng
                                                        : this.props.Language == "krd" ? data.name_krd
                                                        : data.name_ar
                                                    }          
                                                </h5>
                                            </div>
                                            

                                            <p>
                                                {
                                                    this.props.Language == "en" ? data.desc_eng
                                                    : this.props.Language == "krd" ? data.desc_krd
                                                    : data.desc_ar
                                                } 
                                            </p>


                                            
                                                                
                                           

                                            <div className='price'>
                                                
                                                <span 
                                                style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}
                                                > { parseInt(data.price).toLocaleString('en-US')}</span> 
                                                
                                                

                                                <span className='currency ' 
                                                style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}
                                                >{(this.props.Language == "en" ||  this.props.Language == "tr")? 'IQD': 'د.ع.'}</span> 
                                            </div>

                                            <p>
                                                {
                                                    this.props.Language == "en" ? data.desc_eng
                                                    : this.props.Language == "krd" ? data.desc_krd
                                                    : data.desc_ar
                                                }
                                            </p>

                                            


                                        </div>

                                        

                                        
                                    );
                    }} >

                        {
                            this.state.selectCategory.subCat
                            ? 
                                <div className="categories">
                                    {
                                        this.state.selectCategory.subCategories?.map(
                                            cat => <Subcategory  key={cat.id}  Data = {cat} Language = {this.props.Language} Active = {this.state.selectSubCategory.id == cat.id} handleSubCategory = { this.handleSubCategory} />
                                        )
                                    }
                                </div>
                            : ''
                        }
                        </PhotoProvider>
                    </>
                    : <Loader></Loader>
                }


                <div className='items' id='itemContainer'>

                    

                    {
                        
    
                        this.state.loadCat ?
                            <PhotoProvider maskOpacity={0.7} photoClassName={'photoProviderImg'} 
                            overlayRender={ ({ images, index }) => {
                                
                                

                                if(!images[index]){
                                    return null;
                                }
                                const data = images[index].overlay;                                                                
                                                            
                                return (
                                    
                                   
                                    
                                    <div className={`item-photo-view`} style={ {'direction': isLtr? "ltr" : "rtl"} }>
                                         

                                        <div >
                                            <h5 style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}>
                                                {
                                                    this.props.Language == "en" ? data.name_eng
                                                    : this.props.Language == "krd" ? data.name_krd
                                                    : data.name_ar
                                                }          
                                            </h5>
                                        </div>

                                        

                                        <div className='price'  > 
                                            {
                                                (data.price_small && data.price_max)? 
                                                    <>
                                                        
                                                        <span  style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}> 
                                                            { this.priceText('small') } 
                                                        <strong>: &nbsp;</strong>
                                                            {data.price_small} 
                                                            <strong>&nbsp;</strong>

                                                            <span className='currency ' 
                                                                style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}
                                                                >{(this.props.Language == "en" ||  this.props.Language == "tr")? 'IQD': 'د.ع.'}    
                                                            </span> 
                                                        </span>
                                                        <span style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}> 
                                                        { this.priceText('medium') } 
                                                        <strong>: &nbsp;</strong>
                                                            {data.price} 
                                                            <strong>&nbsp;</strong>
                                                            <span className='currency ' 
                                                                style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}
                                                                >{(this.props.Language == "en" ||  this.props.Language == "tr")? 'IQD': 'د.ع.'}    
                                                            </span> 
                                                        
                                                        </span> 
                                                        
                                                    
                                                                
                                                        
                                                        <span> 
                                                            { this.priceText('big') }
                                                            <strong>: &nbsp;</strong>
                                                            {data.price_max} 
                                                            <strong>&nbsp;</strong>
                                                            <span className='currency ' 
                                                                style={ this.props.Language == "en"? {'fontFamily':'Vidaloka'}: {}}
                                                                >{(this.props.Language == "en" ||  this.props.Language == "tr")? 'IQD': 'د.ع.'}    
                                                            </span>  
                                                        
                                                        </span>  
                                                    </>
                                                :
                                                (data.price_small)?
                                                <>
                                                    
                                                    <span> 
                                                        { this.priceText('small') }
                                                        {data.price_small} 
                                                    </span>

                                                    <span> 
                                                        { this.priceText('medium') } 
                                                        {data.price} 
                                                    </span> 

                                                </>
                                                :
                                                (data.price_max)?
                                                <>
                                                    <span> 
                                                        { this.priceText('medium') }  
                                                        {data.price} 
                                                    </span> 
                                                    <span> 
                                                        { this.priceText('big') }
                                                        {data.price_max} 
                                                    </span> 
                                                </>
                                                :
                                                <span
                                                style={ this.props.Language == "en"? {'fontFamily':'Vidaloka' }: {}}> {data.price} 
                                                    <span className='currency'>
                                                        {(this.props.Language == "en")? 'IQD': 'د.ع.'} 
                                                    </span> 
                                                </span> 

                                            }  
                                        </div>

                                       

                                      
                                        
                                    </div>

                                    
                                );
                        }} >
                            
                            
                            <div className={this.state.isAnimationVisible ? 'style-two  ani-btt':  'style-two'} >
                                { 
                                    this.state.selectCategory.subCat ?
                                    this.state.items[this.state.selectSubCategory?.id]?.map(item => <Two key={item.id}  Data = {item} Language = {this.props.Language} addCartItem = {this.props.addCartItem } ></Two> ) 
                                    : this.state.items[this.state.selectCategory?.id]?.map(item => <Two key={item.id}  Data = {item} Language = {this.props.Language} addCartItem = {this.props.addCartItem } ></Two> ) 
                                } 
                            </div>

                            

                        </PhotoProvider>
                        : <Loader></Loader>

                    }

                    

                    
                </div>

                



                <div 
                        className={`language-wrapper ${this.state.showLangSelect? '': 'd-none'}`} 
                        onClick={ () => this.handleShowLangSelect(false)} >
                    <div className={`language-select`}>
                        <div className='language-select-head'><span>Language</span> <i className="fa-solid fa-angle-up"></i></div>
                        <ul>
                            <li className={`${this.props.Language === "krd"? 'language-select-active': ''}`} onClick={() => this.handleChange('krd')}>کوردی</li>
                            <li className={`${this.props.Language === "ar"? 'language-select-active': ''}`} onClick={() => this.handleChange('ar')}>العربیة</li>
                            <li className={`${this.props.Language === "en"? 'language-select-active': ''}`} style={{'textAlign': 'left'}} onClick={() => this.handleChange('en')}>English</li>
                        </ul>
                    </div>
                </div>


                <Cart Cart={this.props.Cart}
                        SumPrice={this.props.SumPrice}
                        SumQty={this.props.SumQty}
                        Language = {this.props.Language} 
                        Show = {this.state.cart}
                        clearCartItem = {this.props.clearCartItem}
                        updateCartItem = {this.props.updateCartItem}
                        HandleCartClose = {this.handleCartClose} />
                
                
            </div>
            </>
        );
    }
}

export default Menu;